
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job/[...id]",
      function () {
        return require("private-next-pages/job/[...id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job/[...id]"])
      });
    }
  